export default class Accordion {
	constructor(block) {
		this.block = block;

		if (!this.block) {
			return;
		}

		this.hiddenBlocks = this.block.querySelectorAll(".is-hidden");
		this.loadMore = this.block.querySelector(".load-more-link");

		this.registerClickHandlers();
		this.registerMoreClick();
	}

	registerMoreClick() {
		this.loadMore.addEventListener(
			"click",
			this.handleLoadMoreClick.bind(this)
		);
	}

	registerClickHandlers() {
		this.block.addEventListener("click", this.handleAccordionClick);
	}

	handleLoadMoreClick(e) {
		e.preventDefault();

		for (const hiddenEl of this.hiddenBlocks) {
			hiddenEl.classList.remove("is-hidden");
		}

		this.loadMore.classList.add("is-hidden");
	}

	handleAccordionClick(e) {
		if (!e.target.tagName === "A" && !e.target.classList.contains("wrapper")) {
			return;
		}

		if (e.target.classList.contains("load-more-link")) {
			return;
		}

		const answer = e.target.querySelector(".answer");

		e.preventDefault();
		e.target.classList.toggle("is-open");

		if (e.target.classList.contains("is-open")) {
			answer.style.height = `${answer.scrollHeight / 16}rem`;
		} else {
			answer.style.height = `0`;
		}
	}
}
